<template>
  <div class="home">
    <div class="home-center-swiper">
      <swiper :options="swiperOptions">
        <Swiper-slide  @click.native="clickSlider(item)" v-for="(item, index) in bannerList" :key="item.id">
          <img
            class="box cov-img"
            :src="item.imgUrl"
            alt=""
          >
        </Swiper-slide>
      </swiper>
<!--      <div class="center-swiper-pagination"></div>-->
    </div>

    <div class="pane center">
      <div class="news-pane">
        <pane-title title="新闻中心" subTitle="News Center"/>

        <div class="n-p-con">
          <div class="n-p-swiper">
            <swiper :options="newsSwiperOptions">
              <swiper-slide v-for="item in newsList" :key="item.id" >
                <div class="box">
                  <div class="img">
                    <div class="mask"></div>
                    <img :src="item.pcImgUrl" alt="">
                  </div>
                  <div class="news-con">
                    <a
                      style="cursor: pointer"
                      class="tit wrap-txt"
                      @click="jumpDetail(item)"
                    >{{item.title}}</a>
                    <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
                      {{item.description}}
                      <a style="cursor: pointer"
                        class="link-tag-small"
                        @click="jumpDetail(item)"
                        target="_blank"
                      >&lsaquo;&nbsp;{{ lang === 'zh' ? '详情' : 'More' }}&nbsp;&rsaquo;</a>
                    </p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="n-p-pagination"></div>
          </div>
        </div>
      </div>


      <div class="act-pane">
        <pane-title title="活动预告" subTitle="Upcoming Events"/>

        <div class="act-list">
          <div class="list-item" v-for="item in actList" :key="item.id">
            <calendar-item :date="item.publishTime" />
            <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">{{item.title}}</p>
          </div>
        </div>
<!--        <p class="to-detail">-->
<!--          <span class="link-tag-lg" @click="toPage('/pc/activity')">查看详情&nbsp;&rsaquo;</span>-->
<!--        </p>-->
      </div>
    </div>

    <div class="act-case">
      <div class="center">
        <pane-title title="活动案例" sub-title="Event Cases" />
      </div>
      <div class="swiper-wrap bg-box">
        <swiper class="a-c-swiper center" :options="acSwiperOptions">
          <swiper-slide
              class="swiper-slide"
              v-for="item in actCaseList"
              :key="item.id"
          >
            <div class="box">
              <div class="img">
                <img :src="item.pcImgUrl" alt="">
              </div>
              <p class="tit wrap-txt">
                <a target="_blank" @click.prevent="jumpDetail(item)">{{item.title}}</a>
              </p>
              <p class="line-box"></p>
              <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">{{item.description}}</p>
              <p class="to-detail">
                <a class="link-tag-lg" @click="jumpDetail(item)" target="_blank">
                  {{lang === 'zh' ? '了解详情' : 'More'}}&nbsp;&rsaquo;
                </a>
              </p>
            </div>
          </swiper-slide>
        </swiper>

        <div class="a-c-pagination"></div>
      </div>
    </div>

    <div class="coop-partner center">
      <pane-title title="合作伙伴" sub-title="Forum Members" />

      <div class="partner-list">
        <div class="item" v-for="item in partnerList" :key="item.id">
          <img
            class="cov-img"
            :src="item.imgUrl"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'home',
  components: {
    Swiper, SwiperSlide
  },
  data() {
    return {
      bannerList: [],
      partnerList: [],
      newsList: [],
      actCaseList: [],
      actList: [],
      swiperOptions: {
        autoplay: true,
        duration: 5000,
        //item click invalid in loop mode https://github.com/surmon-china/vue-awesome-swiper/issues/131
        loop: true,
        pagination: {
          el: '.center-swiper-pagination',
          clickable: true
        }
      },
      newsSwiperOptions: {
        autoplay: true,
        duration: 5000,
        pagination: {
          el: '.n-p-pagination',
          clickable: true
        }
      },
      acSwiperOptions: {
        autoplay: true,
        centeredSlides: true,
        loop: true,
        initialSlide: 1,
        slidesPerView: 3,
        pagination: {
          el: '.a-c-pagination',
          clickable: true
        }
      }
    }
  },
  methods: {
    clickSlider(item) {
      //后端暂时没有该功能，前端写死。
      if(item.id === '61cd2c6d96b7d12ae27845c2'){
        this.toPage('/pc/forum');
      }else if(item.id == '63c10982c4f1571ef252afa2'){
        let itemId = this.lang === 'en' ? '63d8736d774f54243b88f384' : '63c103aac4f1571ef252afa0'

        window.open('/pc/detail/' + itemId + '?lang=' + this.lang);

      }
    },
    toPage(path) {
      this.$router.push(this.lang === 'zh' ? path : '/us' + path);
      document.getElementById('app').scrollIntoView({ block: 'start' })
    },
    jumpDetail(item) {
      const link = item.jumpUrl;
      if(link === 'local') {
        window.open('/pc/detail/' + item.id + '?lang=' + this.lang);
      } else if(link) {
        window.open(link)
      }
    },
    filterData(records) {
      // this.newsList = records['101'];
      this.actList = records['102'].sort((prev, next) => {
        return next.publishTime - prev.publishTime ;
      });
      this.actCaseList = records['103'].sort((a, b) => a.sort - b.sort);
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '1',
        platform: 'pc',
        language
      }).then(res => {
        const records = res.records || [];
        this.filterData(res.crmOweContentMaps || {});
        this.bannerList = res.imageMaps['10'];
        this.partnerList = res.imageMaps['11'];
      })
    },
    getNewsData(language) {
      this.$http.getContentByPageOrder({
        itemType: '3',
        platform: 'pc',
        language,
        pageNo: 1,
        pageSize: 5,
        labelNo: '301',
        orderFlag: 1
      }).then(res => {
        this.newsList = res.records || [];
        // this.filterData(res.crmOweContentMaps || {});
        // this.banner = res.imageMaps['30'][0];
      });
    },
    getNewsDataByLang(lang) {
      if(lang === 'zh') {
        this.getNewsData('china');
      } else {
        this.getNewsData('english');
      }
    },
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
        this.getNewsDataByLang(v);
      }
    }
  }
}
</script>
<style lang="less">
.pc-home {
  .home {
    .home-center-swiper {
      position: relative;
      margin-bottom: 87px;
      .swiper-container {
        .box {
          //height: 576px;
        }
      }
      .center-swiper-pagination {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 74px;
        z-index: 1;
        .swiper-pagination-bullet {
          width: 14px;
          height: 14px;
          border: 1px solid #037698;
          margin: 0 6px;
          opacity: 1;
          background: transparent;
        }
        .swiper-pagination-bullet-active {
          background: #037698;
        }
      }
    }

    .pane {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      >div {
        width: 50%;
      }
      .news-pane {
        .n-p-con {
          padding-right: 70px;
          border-right: 1px solid #a0a0a0;
        }
        .n-p-swiper {
          position: relative;
          .box {
            .img {
              height: 320px;
              margin-bottom: 46px;
              overflow:hidden;
              position: relative;
              .mask {
                position: absolute;
                width: 100%;
                height: 320px;
                top: 0;
                left: 0;
                box-shadow: 0 -48px 18px -16px rgba(0,0,0,.4) inset;
              }
              img{
                display: block;
                width:100%;
                height:100%;
                object-fit:cover;
              }
            }
          }
          .n-p-pagination {
            width: 100%;
            text-align: center;
            position: absolute;
            top: 270px;
            z-index: 1;
            .swiper-pagination-bullet {
              width: 14px;
              height: 14px;
              border: 1px solid #B5E5E7;
              margin: 0 6px;
              opacity: 1;
              background: transparent;
            }
            .swiper-pagination-bullet-active {
              background: #B5E5E7;
            }
          }

          .news-con {
            .tit {
              display: block;
              font-size: 18px;
              font-weight: bolder;
              color: #037698;
              margin-bottom: 16px;
              text-decoration: none;
            }
            .txt {
              text-indent: 2em;
              line-height: 29px;
            }
          }
        }
      }
      .pane-line {
        width: 1px;
        background: #a0a0a0;
        height: 300px;
        align-self: flex-end;
      }
      .act-pane {
        padding-left: 70px;
        .act-list {
          .list-item {
            display: flex;
            margin-bottom: 43px;
            p {
              width: calc(100% - 94px);
              margin-left: 24px;
            }
          }
        }
        .to-detail {
          text-align: right;
        }
      }
    }
    .act-case {
      margin-top: 87px;
      margin-bottom: 87px;
      //.pane-title {
      //  margin: 86px auto 50px;
      //  width: 1000px;
      //}
      .swiper-wrap {
        padding: 50px 0 30px 0;
        background-image: url("../../assets/bg-1.jpg");
      }
      .a-c-swiper {
        .swiper-slide {
          width: calc(39700vw / 1950);
          box-shadow: 0 0 10px #eee;
          transform: scale(.9);
          transition: .3s;
          background: #fff;
          .img {
            display: block;
            width: calc(100% - 12px);
            margin: 6px auto 31px;
            height: calc(25000vw / 1950);
            overflow: hidden;
            img{
              display: block;
              width:100%;
              height:100%;
              object-fit:cover;
            }
          }
          .tit, .txt, .to-detail {
            padding: 0 18px;
          }
          .tit {
            font-size: 24px;
            font-weight: bolder;
            margin-bottom: 28px;
          }
          .line-box {
            width: 63px;
            height: 10px;
            border-radius: 5px;
            background: #b5e5e7;
            margin-left: 18px;
            margin-bottom: 35px;
          }
          .txt {
            text-indent: 2em;
            line-height: 29px;
            margin-bottom: 20px;
            overflow: hidden;
            height: 88px;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient:vertical;
          }
          .to-detail {
            margin-bottom: 51px;
          }
        }
        .swiper-slide-active {
          transform: scale(.98);
        }
      }
      .a-c-pagination {
        width: 100%;
        text-align: center;
        margin-top: 30px;
        .swiper-pagination-bullet {
          width: 14px;
          height: 14px;
          border: 1px solid #037698;
          margin: 0 6px;
          opacity: 1;
          background: #fff;
        }
        .swiper-pagination-bullet-active {
          background: #037698;
        }
      }
    }

    .coop-partner {
      margin-bottom: 86px;
      .partner-list {
        font-size: 0;
        .item {
          display: inline-block;
          width: calc((100% - 100px) / 5);
          box-shadow: 0 0 10px #eee;
          margin-bottom: 25px;
          height: 81px;
          margin-left: 25px;
          &:nth-child(5n + 1) {
            margin-left: 0;
          }
          img {
            width: 100%;
            display: block;
          }
        }
      }
    }
  }
}
</style>
